import React from "react";
import ReactDOM from "react-dom";
import "typeface-roboto";
import "@sincro/icons";
import "@sincro/react/cdk.css";
import "@sincro/react-global-header-and-navigation/dist/global-header-and-navigation.css";
import "./styles/index.scss";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { AppContainer } from "./AppContainer";
import { UrlBuilder } from "@sincro/url-builder";

const urlUtil = new UrlBuilder();

// For baseHref, grab current URL pathname up to the /dcc segment before a slash, query, hash, or string end:
let regex = /.*\/dcc(\/[0-9.]+)?(?=([?/#]|$))/;
let result = regex.exec(window.location.pathname);
const baseHref = result ? result[0] : "/dcc";

  ReactDOM.render(
    <Router basename={baseHref}>
      <Route path="/" component={AppContainer} />
    </Router>,
    document.getElementById("root")
  );
